




































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Button, Form, FormItem, Input, RadioGroup, Radio, Option, Select } from 'element-ui';
import incoterms from '@/constants/incoterms';
import { SelectOption } from '@/types/types';
import {
  IncotermsTypeEnum,
  ShipmentFields,
  ShipmentUpdateInput
} from '@/types/graphql/schemaTypes';
import pick from 'lodash/pick';

@Component({
  components: {
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-radio': Radio,
    'el-radio-group': RadioGroup,
    'el-option': Option,
    'el-select': Select
  }
})
export default class PaymentInfo extends Vue {
  @Prop() public shipment!: ShipmentFields;

  private editMode = false;
  private incotermsOptions: SelectOption<string>[] = [];
  private shipmentInput: ShipmentUpdateInput = {} as ShipmentUpdateInput;

  private created() {
    this.setShipmentInput(this.shipment);
    this.incotermsOptions = [
      {
        value: null,
        label: this.$i18n.t('incoterms.any') as string
      }
    ].concat(incoterms);
  }

  private toggleEdit() {
    this.editMode = !this.editMode;
  }

  // restor prop values
  private cancel() {
    this.toggleEdit();
  }

  private submit() {
    this.$store.dispatch('Shipment/updateShipment', this.shipmentInput);
    this.toggleEdit();
  }

  @Watch('shipment')
  private setShipmentInput(shipment: ShipmentFields) {
    // copy only the needed fields
    this.shipmentInput = pick(
      shipment,
      ['id', 'incoterm', 'paymentTerms', 'paymentAsArranged', 'paymentPlace']);
  }
}
